import { ResizableHandle } from '@ibsys/kit';
import type { ComponentProps, FC, Ref } from 'react';

type Props = ComponentProps<typeof ResizableHandle> & {
  /** Ссылка на элемент границы — её ставит обёртка подсказки. */
  ref?: Ref<HTMLDivElement>;
};

/**
 * Граница панелей, к которой можно приложить подсказку.
 *
 * Граница библиотеки распоряжается своим элементом сама: ссылку на него и обработчики фокуса
 * она задаёт поверх пришедших снаружи, и подсказке, которая ставит их обычным путём, не остаётся
 * ни к чему привязаться. Ссылку граница принимает отдельным свойством и объединяет со своей,
 * а фокус подсказке отдаётся в фазе перехвата — там их обработчики не спорят.
 */
export const ResizeHandleWithRef: FC<Props> = ({ ref, onFocus, onBlur, ...props }) => (
  <ResizableHandle {...props} elementRef={ref} onFocusCapture={onFocus} onBlurCapture={onBlur} />
);
